import { NICmsContentComponent } from '@icms/core/content';

export namespace NCmsOutletBlock {
    export const BLOCK_ID = 'cms-outlet-block';

    export interface IBlockDataContent extends NICmsContentComponent.IData {
        components: NICmsContentComponent.IData[];
    }
}
